import Vue from "vue";
import Vuex from "vuex";
import shop from "./shop";
import settings from "./settings";
import campaigns from "./campaigns";
import automations from "./automations";
import { httpClient } from "../helpers/httpClient";
import { APP_API_URL, APP_API_VERSION } from "../helpers/configuration";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appReady: false,
    loading: false,
    loadingSubs: false,
    loadingSubsFailed: true,
    query: {},
    store: {
      enfonicaAccessToken: "",
      onboardingState: "NOT_REGISTERED"
    },
    error: null,
    success: null
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setLoadingSubs(state, payload) {
      state.loadingSubs = payload;
    },
    setLoadingSubsFailed(state, payload) {
      state.loadingSubsFailed = payload;
    },
    setAppReady(state, payload) {
      state.appReady = payload;
    },
    setQuery(state, payload) {
      state.query = payload;
    },
    setStore(state, payload) {
      state.store = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    clearError(state) {
      state.error = null;
    },
    setSuccess(state, payload) {
      state.success = payload;
    },
    clearSuccess(state) {
      state.success = null;
    }
  },
  actions: {
    setError({ commit }, payload) {
      commit("setError", payload);
    },
    clearError({ commit }) {
      commit("clearError");
    },
    setSuccess({ commit }, payload) {
      commit("setSuccess", payload);
    },
    clearSuccess({ commit }) {
      commit("clearSuccess");
    },
    updateQuery({ commit }, payload) {
      commit("setQuery", payload);
    },
    updateLoading({ commit }, payload) {
      commit("setLoading", payload);
    },
    updateAppReady({ commit }, payload) {
      commit("setAppReady", payload);
    },
    updateStore({ commit }, payload) {
      commit("setStore", payload);
    },
    registerStore({ commit, state, rootState }, payload) {
      commit("setLoading", true, { root: true });
      const storeName = rootState.store.name;
      const accessToken = rootState.store.enfonicaAccessToken;

      return httpClient
        .patch(
          `${APP_API_URL}${APP_API_VERSION}/${storeName}?update_mask=email,phone,onboarding_state`,
          {
            email: payload.email,
            phone: payload.phone,
            onboardingState: "REGISTERED"
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        )
        .then(res => {
          commit("setLoading", false, { root: true });
          commit("setSuccess", { data: "Store registered" }, { root: true });
          return res.data;
        })
        .catch(error => {
          commit("setLoading", false, { root: true });
          commit("setError", { data: "Store error" }, { root: true });
          console.log(error);
        });
    },
    onboardStore({ commit, state, rootState }, payload) {
      commit("setLoading", true, { root: true });
      const storeName = rootState.store.name;
      const accessToken = rootState.store.enfonicaAccessToken;

      return httpClient
        .patch(
          `${APP_API_URL}${APP_API_VERSION}/${storeName}?update_mask=onboarding_state`,
          {
            onboardingState: "ONBOARDED"
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        )
        .then(res => {
          commit("setLoading", false, { root: true });
          commit("setSuccess", { data: "Onboarding complete" }, { root: true });
          return res.data;
        })
        .catch(error => {
          commit("setLoading", false, { root: true });
          commit("setError", { data: "Onboarding error" }, { root: true });
          console.log(error);
        });
    }
  },
  modules: {
    // @ts-ignore
    shop,
    settings,
    campaigns,
    automations
  }
});
